"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFormField = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const defaultStyles = (theme) => ({
    leftContainer: {
        paddingRight: theme.spacing.unit * 2,
    },
    mainContainer: {
        flex: 1,
    },
    rightContainer: {
        paddingLeft: theme.spacing.unit * 2,
    },
    root: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        paddingHorizontal: theme.spacing.unit * 2,
        paddingVertical: theme.spacing.unit * 2,
    }
});
const BaseFormField = (props) => {
    const { MainComponent, children, left, right, styles: _styles } = props, rest = tslib_1.__rest(props, ["MainComponent", "children", "left", "right", "styles"]);
    const styles = core_1.useStyles('BaseFormField', props, defaultStyles);
    return (react_1.default.createElement(components_1.View, { style: styles.root, testID: "base-form-field" },
        left && react_1.default.createElement(components_1.View, { style: styles.leftContainer, testID: "base-form-field-left" }, left),
        MainComponent &&
            react_1.default.createElement(components_1.View, { style: styles.mainContainer, testID: "base-form-field-main" },
                react_1.default.createElement(MainComponent, Object.assign({}, rest), children)),
        right && react_1.default.createElement(components_1.View, { style: styles.rightContainer, testID: "base-form-field-right" }, right)));
};
exports.BaseFormField = BaseFormField;
